import { useNavigate } from 'react-router-dom'
import '@/style/common/footer.scss'
import footerLogo from '@/images/home/logo_name_white.png'

const MENU = [
  {
    text: '关于我们',
    href: '/intro',
    children: [{ text: '公司简介', href: '/intro?type=overview' }],
  },
  {
    text: '产品',
    href: '/industry',
    children: [
      { text: '应用领域', href: '/industry?type=applicationDomain' },
      { text: '产品展示', href: '/industry?type=industryShow' },
    ],
  },
  {
    text: '体系认证',
    href: '/systemCert',
    children: [{ text: '体系认证', href: '/systemCert?type=systemCert' }],
  },
  {
    text: '合作案例',
    href: '/cooperationCase',
    children: [{ text: '合作案例', href: '/cooperationCase?type=cooperationCase' }],
  },
  {
    text: '新闻中心',
    href: '/news',
    children: [{ text: '新闻中心', href: '/news?type=news' }],
  },
  {
    text: '联系我们',
    href: '/contact',
    children: [{ text: '联系我们', href: '/contact?type=contactUs' }],
  },
]

const CONTACT = [
  { label: '办公地址', value: '河北省保定市涿州市高官庄镇解家楼村村北' },
  { label: '联系电话', value: '139 1110 2112' },
  { label: '电子邮箱', value: '120299424@qq.com' },
]

function Footer() {
  const navigate = useNavigate()

  // 站内链接统一走路由跳转，避免整页刷新
  const go = (href) => (e) => {
    e.preventDefault()
    navigate(href)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className="siteFooter">
      <div className="mainContent siteFooter__top">
        <div className="siteFooter__brand">
          <a href="/home" onClick={go('/home')} className="siteFooter__logo">
            <img src={footerLogo} alt="丰源电力科技（涿州）有限公司" />
          </a>
          <p className="siteFooter__slogan">
            电力技术开发、咨询和推广应用
            <br />
            金属结构件及电力电子元器件加工销售
          </p>
        </div>

        <nav className="siteFooter__nav" aria-label="页脚导航">
          {MENU.map((group) => (
            <div className="siteFooter__col" key={group.href}>
              <a className="siteFooter__colTitle" href={group.href} onClick={go(group.href)}>
                {group.text}
              </a>
              {group.children.map((sub) => (
                <a
                  className="siteFooter__link"
                  key={sub.href}
                  href={sub.href}
                  onClick={go(sub.href)}
                >
                  {sub.text}
                </a>
              ))}
            </div>
          ))}
        </nav>

        <div className="siteFooter__contact">
          {CONTACT.map((item) => (
            <div className="siteFooter__contactItem" key={item.label}>
              <span>{item.label}</span>
              <p>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="siteFooter__bottom">
        <div className="mainContent siteFooter__bottomInner">
          <p>© {new Date().getFullYear()} 丰源电力科技（涿州）有限公司 版权所有</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer